module.exports = __webpack_public_path__ + "img/1472981729.b55b6dd9.jpg";